import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getCafesRestaurantsPage } from "@/_pages/cafes-restaurants/api";
import type {
  CafesRestaurantsBadgeType,
  CafesRestaurantsPageType,
  CafesRestaurantsPoints,
  CafesRestaurantsType,
} from "@/_pages/cafes-restaurants/model/types";
import { CafesRestaurantsPage } from "@/_pages/cafes-restaurants/ui";

type PageProps = {
  cms: {
    filters: CafesRestaurantsType[];
    badges: CafesRestaurantsBadgeType[];
    list: CafesRestaurantsPoints;
    hero: CafesRestaurantsPageType;
  };
};

const Page = (props: PageProps) => {
  const {
    cms: { filters, badges, list, hero },
  } = props;

  return (
    <CafesRestaurantsPage
      filters={filters}
      badges={badges}
      content={list}
      hero={hero}
    />
  );
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getCafesRestaurantsPage()),
      };
    },
    { res },
  );
}

export default Page;
